import { createEntityAdapter } from '@reduxjs/toolkit'

import { ClientContextCompanyUser } from '../types'

const clientContextCompanyUsersEntityAdapter =
  createEntityAdapter<ClientContextCompanyUser>()

export default clientContextCompanyUsersEntityAdapter
